// authReducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  providers: [], // Stores all practices
};

export const providerSlice = createSlice({
  name: "provider",
  initialState,
  reducers: {
    setProviders: (state, action) => {
      state.providers = action.payload;
    },
  },
});

export const { setProviders } =
  providerSlice.actions;
export default providerSlice.reducer;
